import dayjs from 'dayjs'

import { DeliverableSetStatus, ResponseDeliverableSet } from '@/schema'

export const isAllowedChangeStatus = (
  newStatus: string,
  currentStatus: string
): boolean => {
  if (currentStatus === newStatus) {
    return true
  }

  // can't change from draft to in review
  if (
    currentStatus === DeliverableSetStatus.DRAFT &&
    newStatus === DeliverableSetStatus.IN_REVIEW
  ) {
    return false
  }

  // can't change from in review to draft or approved
  if (
    currentStatus === DeliverableSetStatus.IN_REVIEW &&
    newStatus === DeliverableSetStatus.DRAFT
  ) {
    return false
  }

  if (
    currentStatus === DeliverableSetStatus.IN_REVIEW &&
    newStatus === DeliverableSetStatus.APPROVED
  ) {
    return true
  }

  // can change from approved to in review or archived
  if (
    currentStatus === DeliverableSetStatus.APPROVED &&
    (newStatus === DeliverableSetStatus.IN_REVIEW ||
      newStatus === DeliverableSetStatus.ARCHIVED)
  ) {
    return true
  }

  // can change from archived to approved
  if (
    currentStatus === DeliverableSetStatus.ARCHIVED &&
    newStatus === DeliverableSetStatus.APPROVED
  ) {
    return true
  }

  return false
}

export const isAllowUpload = (
  deliverableSet: ResponseDeliverableSet
): boolean => {
  return ![
    DeliverableSetStatus.APPROVED,
    DeliverableSetStatus.ARCHIVED,
  ].includes(deliverableSet.status)
}

export const canDeleteFiles = (
  deliverableSet: ResponseDeliverableSet
): boolean => {
  return [DeliverableSetStatus.DRAFT].includes(deliverableSet.status)
}

export const validateTargetDateIsOverdue = (
  targetDate: string | null | undefined
): boolean => {
  if (!targetDate) return false
  return dayjs(targetDate).isBefore(dayjs())
}
